var render = function render() {
  var _vm = this,
    _c = _vm._self._c
  return _c(
    "div",
    [
      _c("p", [
        _vm._v(_vm._s(_vm.translate("flyover.feeds.schedules.tab.sort.label"))),
      ]),
      _vm._v(" "),
      _c(
        "mds-button",
        {
          attrs: {
            "icon-right": "caret-down",
            size: "small",
            variation: "flat",
            disabled: _vm.disableSortBy,
          },
        },
        [
          _vm._v(
            "\n    " +
              _vm._s(
                _vm.translate("flyover.feeds.schedules.tab.mostRecent.button")
              ) +
              "\n  "
          ),
        ]
      ),
    ],
    1
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }